/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */


export const RecurrenceType = Object.freeze({
	DAILY: 'daily',
	WEEKLY: 'weekly',
	MONTHLY_ABSOLUTE: 'absoluteMonthly',
	YEARLY_ABSOLUTE: 'absoluteYearly',
	MONTHLY_RELATIVE: 'relativeMonthly',
	YEARLY_RELATIVE: 'relativeYearly',
})
export const RecurrenceRangeType = Object.freeze({
	COUNT: 'numbered',
	BY_DATE: 'endDate',
	NO_END: 'noEnd'
})
